import { Box, BoxProps } from "@mui/material";
import { paletteVar, Typography } from "@platform/design-system";

interface CensusTitleProps extends BoxProps {
  title: string;
}

const CensusTitle = ({
  title,
  ...rest
}: CensusTitleProps): React.JSX.Element => (
  <Box
    bgcolor={paletteVar("surfaces-primary", "#EFF8FB")}
    px={2}
    py={1}
    mb={3}
    {...rest}
  >
    <Typography>
      <strong>{title}</strong>
    </Typography>
  </Box>
);
export default CensusTitle;
